module.exports = __webpack_public_path__ + "img/us.8ec58318.svg";